(() => {
  if (window.PXNativeHome) { window.PXNativeHome.init(document); return; }
  const instances = new Map();
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController(), signal = abort.signal;
    const on = (el, name, callback, options = {}) => el?.addEventListener(name, callback, { ...options, signal });
    let observer, opener;
    const track = root.querySelector('[data-benefit-track]');
    if (track) {
      const prev = root.querySelector('.benefit-arrow.prev'), next = root.querySelector('.benefit-arrow.next');
      const update = () => { if (prev) prev.disabled = track.scrollLeft < 2; if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; };
      [prev, next].forEach((button, index) => on(button, 'click', () => track.scrollBy({ left: (index ? 1 : -1) * (track.clientWidth + 12), behavior: reduced() ? 'instant' : 'smooth' })));
      on(track, 'scroll', update, { passive: true }); observer = new ResizeObserver(update); observer.observe(track); update();
    }
    root.querySelectorAll('[data-px-feedback]').forEach(button => on(button, 'click', () => {
      const target = document.querySelector('[data-review-section]');
      if (target) { target.scrollIntoView({ behavior: reduced() ? 'instant' : 'smooth', block: 'start' }); target.focus({ preventScroll: true }); }
    }));
    const dialog = root.querySelector('.evidence-dialog');
    if (dialog) {
      root.querySelectorAll('[data-evidence]').forEach(button => on(button, 'click', () => { opener = button; dialog.querySelector('img').src = button.dataset.evidence; dialog.showModal(); }));
      on(dialog.querySelector('.evidence-close'), 'click', () => dialog.close());
      on(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      on(dialog, 'close', () => opener?.isConnected && opener.focus());
    }
    if (window.Shopify?.theme?.role === 'unpublished' && location.hostname.endsWith('.myshopify.com')) {
      root.querySelectorAll('a[href]').forEach(a => {
        const raw = a.getAttribute('href'); if (!raw || raw.startsWith('#')) return;
        try { const url = new URL(raw, location.href); if (url.origin !== location.origin || /^\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) return; url.searchParams.set('_fd', '0'); a.href = url.pathname + url.search + url.hash; } catch (_) {}
      });
    }
    instances.set(root, () => { abort.abort(); observer?.disconnect(); if (dialog?.open) dialog.close(); });
  }
  function init(scope) { if (scope.matches?.('[data-px-native-home]')) mount(scope); scope.querySelectorAll('[data-px-native-home]').forEach(mount); }
  window.PXNativeHome = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of instances) if (event.target === root || event.target.contains(root)) { dispose(); instances.delete(root); } });
  document.addEventListener('shopify:block:select', event => { const block = event.target.closest('[data-px-block]'); if (block && block.closest('[data-benefit-track]')) block.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
})();
